import { render, staticRenderFns } from "./ResultDetailCommunicationInLeft.vue?vue&type=template&id=2ef1f118&scoped=true&"
import script from "./ResultDetailCommunicationInLeft.vue?vue&type=script&lang=js&"
export * from "./ResultDetailCommunicationInLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1f118",
  null
  
)

export default component.exports